<template>
  <li ref="dropdown" class="theme-notifications">
    <a class="theme-notifications__toggler hidden md:block" href="#" @click.prevent="toggleDropdown">
      <i class="icon-notification"></i>
      <i v-if="hasUnread" class="theme-notifications__cirlce"></i>
    </a>

    <a class="theme-notifications__toggler md:hidden" data-feature="open-modal" :data-target="'notifications-modal'">
      <i class="icon-notification"></i>
      <i v-if="hasUnread" class="theme-notifications__cirlce"></i>
    </a>

    <div class="theme-notifications__container">
      <!-- First item, also when there are no unread notifications. -->
      <push-disable-control />
      <div v-show="hasUnread" class="theme-notifications__upper">
        <div class="theme-notifications__title-wrapper">
          <h3 class="theme-notifications__title">Notifications</h3>
          <span class="text-[#7B7C85]">({{ notifications.length }})</span>
        </div>

        <a class="theme-btn theme-btn--text" href="#" @click.prevent="markAllRead">Mark all as read</a>
      </div>
      <ul class="theme-notifications__list" :class="{'bordered': total > 0}">
        <notification v-for="notification in notifications"
                      :key="notification.id"
                      :notification="notification"
                      @read="markAsRead(notification)" />

        <li v-if="!hasUnread" class="theme-notifications__empty-result">
          You don't have any unread notifications.
        </li>
      </ul>

      <div v-if="hasUnread" class="theme-notifications__footer">
        <a  class="theme-btn theme-btn--tertiary theme-btn--small theme-btn--block" href="#" @click.prevent="fetch(null)">
          View All
          <span class="icon-go-right"></span>
        </a>
      </div>
    </div>

    <!-- mobile modal -->
    <div class="modal modal--bottom" data-feature="modal" :data-name="'notifications-modal'">
      <div class="modal__content" data-feature="modal-active-area">
        <button class="modal__close" data-feature="close-modal" :data-target="'notifications-modal'">
          <i class="icon-close"></i>
        </button>

        <push-disable-control in-modal />
        <div v-show="hasUnread" class="theme-notifications__upper">
          <div class="theme-notifications__title-wrapper">
            <h3 class="theme-notifications__title">Notifications</h3>
            <span class="text-[#7B7C85]">({{ notifications.length }})</span>
          </div>

          <a class="theme-btn theme-btn--tertiary theme-btn--small px-0 hover:bg-transparent" href="#" @click.prevent="markAllRead">Mark all as read</a>
        </div>
        <ul class="theme-notifications__list" :class="{'bordered': total > 0}">
          <notification v-for="notification in notifications"
                        :key="notification.id"
                        :notification="notification"
                        @read="markAsRead(notification)" />

          <li v-if="!hasUnread" class="theme-notifications__empty-result">
            You don't have any unread notifications.
          </li>
        </ul>

        <div v-if="hasUnread" class="theme-notifications__footer">
          <a  class="theme-btn theme-btn--tertiary theme-btn--small theme-btn--block" href="#" @click.prevent="fetch(null)">
            View All
            <span class="icon-go-right"></span>
          </a>
        </div>

      </div>
    </div>

  </li>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'
  import Notification from './Notification.vue'
  import PushDisableControl from './PushDisableControl.vue'
  export default {
    components: { Notification, PushDisableControl },
    data: () => ({
      total: 0,
      notifications: [],
    }),
    computed: {
      hasUnread() {
        return this.total > 0
      }
    },
    mounted() {
      this.fetch()
      if (window.Echo) {
        this.listen()
      }
      this.initDropdown()
    },
    methods: {
      /**
       * Fetch notifications.
       *
       * @param {Number} limit
       */
      fetch(limit = 5) {
        var that = this;
        axios.get('/api/notifications', { params: { limit } })
          .then(({ data: { total, notifications } }) => {
            that.total = total;
            that.notifications = notifications.map(({ id, data, created }) => {
              return {
                id: id,
                icon: data.icon,
                title: data.title,
                body: data.body,
                created: created,
                action_url: data.action_url
              }
            })
          })
      },
      /**
       * Mark the given notification as read.
       *
       * @param {Object} notification
       */
      markAsRead({ id }) {
        const index = this.notifications.findIndex(n => n.id === id)
        if (index > -1) {
          this.total--
          this.notifications.splice(index, 1)
          axios.patch(`/api/notifications/${id}/read`)
        }
      },
      /**
       * Mark all notifications as read.
       */
      markAllRead() {
        this.total = 0
        this.notifications = []
        axios.post('/api/notifications/mark-all-read')
      },
      /**
       * Listen for Echo push notifications.
       */
      listen() {
        window.Echo.private(`App.Domains.User.User.${window.Laravel.user.id}`)
          .notification(notification => {
            this.total++
            this.notifications.unshift(notification)
          })
          .listen('NotificationRead', ({ notificationId }) => {
            this.total--
            const index = this.notifications.findIndex(n => n.id === notificationId)
            if (index > -1) {
              this.notifications.splice(index, 1)
            }
          })
          .listen('NotificationReadAll', () => {
            this.total = 0
            this.notifications = []
          })
      },
      /**
       * Initialize the notifications dropdown.
       */
      initDropdown() {
        const dropdown = $(this.$refs.dropdown)
        $(document).on('click', (e) => {
          if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0 &&
            !$(e.target).parent().hasClass('notification-mark-read')) {
            dropdown.removeClass('open')
          }
        })
      },
      /**
       * Toggle the notifications dropdown.
       */
      toggleDropdown() {
        $(this.$refs.dropdown).toggleClass('open')
      }
    }
  }
</script>